__turbopack_context__.v({
  "closeButton": "FeaturedHeroVideo-module-scss-module__D-3w5G__closeButton",
  "modal": "FeaturedHeroVideo-module-scss-module__D-3w5G__modal",
  "modalContainer": "FeaturedHeroVideo-module-scss-module__D-3w5G__modalContainer",
  "modalVideoWrapper": "FeaturedHeroVideo-module-scss-module__D-3w5G__modalVideoWrapper",
  "overlay": "FeaturedHeroVideo-module-scss-module__D-3w5G__overlay",
  "playButton": "FeaturedHeroVideo-module-scss-module__D-3w5G__playButton",
  "playButtonIcon": "FeaturedHeroVideo-module-scss-module__D-3w5G__playButtonIcon",
  "root": "FeaturedHeroVideo-module-scss-module__D-3w5G__root",
});
